/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 * Token Format
 * Enumerates design token delivery formats
 */
import * as t from 'io-ts';
export const schemaId = 'TokenFormat';
export const TokenFormat = t.union([t.literal('css'), t.literal('json')], 'TokenFormat');
export default TokenFormat;
// Success
//# sourceMappingURL=TokenFormat.js.map